import React, { useState } from 'react'
import { AppBar } from '@material-ui/core'

import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import SitesList from './SitesList'
import Facilities from '.'

const SitesTabs = () => {
  const [mainTab, setMainTab] = useState('LISTVIEW')

  return (
    <>
      <div style={{ height: 'calc(100vh - 64px)', background: '#fff' }}>
        <div className='assets-box-wraps customtab' style={{ padding: '20px 20px 0px 20px' }}>
          <AppBar position='static' color='inherit'>
            <Tabs id='controlled-tab-example' activeKey={mainTab} onSelect={k => setMainTab(k)}>
              <Tab eventKey='LISTVIEW' title='Hierarchy View' tabClassName='font-weight-bolder small-tab'></Tab>
              <Tab eventKey='COLUMN-VIEW' title='Column View' tabClassName='font-weight-bolder small-tab'></Tab>
            </Tabs>
          </AppBar>
        </div>
        {mainTab === 'LISTVIEW' && <SitesList />}
        {mainTab === 'COLUMN-VIEW' && <Facilities />}
      </div>
    </>
  )
}

export default SitesTabs
